<template>
  <div id="about" class="about">
    <div class="about-background">
      <v-img class="about-title" src="../assets/img/about-title.png" />
      <div class="about-title2">
        <v-img class="about-title2-heart1" src="../assets/img/about-heart.png" />
        <v-img class="about-title2-heart2" src="../assets/img/about-heart.png" />
        <p class="about-title2-text">癒されたいと思った<span>全ての人へ。</span></p>
      </div>
      <div class="about-text">
        <v-img class="about-text-img" src="../assets/img/about-image.png" />
        <p class="about-text-1">
          <span style="color: #ff6eb6">可愛い女の子</span>に慰められたい、甘やかされたい<br />
          そんなあなたが出会った彼女は<br />
          なんと<span style="color: #a967e1">罵倒少女</span>！<br />
          <br />厳しすぎる<span style="color: #3eb0eb">冷たさ</span>に、 あなたはどうする？
        </p>
        <p class="about-text-2">
          もう少し温かみのある言葉が欲しい、<br />
          プレゼントをあげてみると━━<br /><br />
          態度が変化！？<br /><br />これは当たって砕けろ！<br />
          <span style="color: #ff2a03">プレゼント攻撃</span>だ！<br /><br />
          選択次第で変わってゆく彼女の態度。<br />
          プレゼントを渡して仲良くなろう！
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutView',
};
</script>

<style lang="scss" scoped>
.about {
  position: relative;
  background: url(../assets/img/background.png) repeat-y;
  background-size: 200% auto;
  background-attachment: fixed;
  font: 4.3vw 'ヒラギノ丸ゴ Pro W4', 'ヒラギノ丸ゴ Pro', 'Hiragino Maru Gothic Pro';
  text-shadow: 0px 0px 1px white;
  color: #919191;
  line-height: 1.7em;
  letter-spacing: -0.8px;
  @media screen and (min-width: 960px) {
    background-size: 100% auto;
  }
  &-background {
    padding: 20% 0 10%;
    background-color: rgba(255, 255, 255, 0.75);
    z-index: 0;
    @media screen and (min-width: 960px) {
      padding: 10% 0 10%;
    }
  }
  &-title {
    left: 0;
    right: 0;
    margin: 7% auto;
    width: 60%;
    max-width: 600px;
    @media screen and (min-width: 960px) {
      width: 30%;
      margin: 5% auto 10%;
    }
  }
  &-title2 {
    @media screen and (min-width: 960px) {
      width: 60%;
      margin: 0 auto;
    }
    &-text {
      line-height: 1.5em;
      font-size: 7vw;
      width: 100%;
      min-width: 125px;
      padding: 20% 1%;
      right: 0%;
      text-align: center;
      text-shadow: 1.5px 1.5px 1.5px #fff, -1.5px -1.5px 1.5px #fff, -1.5px 1.5px 1.5px #fff, 1.5px -1.5px 1.5px #fff,
        1.5px 0px 1.5px #fff, -1.5px -0px 1.5px #fff, 0px 1.5px 1.5px #fff, 0px -1.5px 1.5px #fff;
      transform: scale(1);
      span {
        padding: 0 0 0 53%;
      }
      @media screen and (min-width: 960px) {
        // background:red;
        white-space: nowrap;
        font-size: 4.2vw;
        text-align: right;
        padding: 0;
        // margin: 0% auto;
        span {
          padding: 0;
        }
      }
    }
    &-heart1 {
      width: 42%;
      position: absolute;
      top: 20%;
      right: 53%;
      transform: rotateZ(-25deg);
      z-index: 0;
      max-width: 400px;
      @media screen and (min-width: 960px) {
        width: 20%;
        top: 24%;
        right: 68%;
        transform: rotateZ(-15deg);
      }
    }
    &-heart2 {
      z-index: 1;
      width: 25%;
      position: absolute;
      top: 33%;
      right: 40%;
      transform: rotateZ(35deg);
      max-width: 250px;
      @media screen and (min-width: 960px) {
        width: 10%;
        top: 40%;
        right: 65%;
      }
    }
  }

  &-text {
    top: 50%;
    right: 2%;
    font-weight: bold;
    text-shadow: 1px 1px 1px #fff, -1px -1px 1px #fff, -1px 1px 1px #fff, 1px -1px 1px #fff, 1px 0px 1px #fff,
      -1px -0px 1px #fff, 0px 1px 1px #fff, 0px -1px 1px #fff;
    @media screen and (min-width: 960px) {
      width: 60%;
      margin: 0 auto;
      letter-spacing: 1.5px;
      font-size: 2vw;
      line-height: 1.5em;
      text-shadow: 2px 2px 2px #fff, -2px -2px 2px #fff, -2px 2px 2px #fff, 2px -2px 2px #fff, 2px 0px 2px #fff,
        -2px -0px 2px #fff, 0px 2px 2px #fff, 0px -2px 2px #fff;
    }

    &-1 {
      width: 100%;
      text-align: right;
      padding: 12% 16px 10% 0;
      @media screen and (min-width: 960px) {
        padding: 5% 10px 5% 0;
      }
    }

    &-2 {
      width: 100%;
      text-align: left;
      padding: 5% 0 10% 16px;
      top: 27%;
      transform: scale(1);
    }
    &-img {
      position: absolute;
      width: 55%;
      top: 66%;
      right: 0%;
      @media screen and (min-width: 960px) {
        width: 30%;
        top: 57%;
        right: 20%;
      }
    }
  }
}
</style>
